import React, { memo } from 'react';
import { useTranslations } from 'js/hooks/i18n';

import * as Types from './types';

import style from './GameProvider.scss';

export const GameProviderBare: React.FC<Types.IGameProviderProps> = ({ game, className = '' }) => {
    const translate = useTranslations();
    const { gameProvider } = game;

    if (!gameProvider) {
        return null;
    }

    return <span className={`${style.gameProvider} ${className} cms-games-grid-game-provider`}>{translate(`playtech.mobile.system.gameprovider.${gameProvider}`, gameProvider)}</span>;
};

export const GameProvider = memo(GameProviderBare);
